import { useState } from "react";
import {
  ParameterFilter,
  ParameterFilterOption,
} from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";

export const useToggleParameterFilter = (
  parameter: ParameterFilterOption,
  appliedFilter?: ParameterFilter | boolean
): [expanded: boolean, toggleIsExpanded: () => void] => {
  const [isExpanded, setIsExpanded] = useState(
    parameter.importance === "order" || appliedFilter !== undefined
  );

  return [isExpanded, () => setIsExpanded(!isExpanded)];
};
